import { NotifyError, NotifySuccess } from "../Notify/notify";

export const GetTorkSettings = (jwtToken, callback) => {
    fetch(process.env.REACT_APP_API_BASE_URL + '/torksettings', {
        headers: {
            Authorization: `Bearer ${jwtToken}`
        }
    })
    .then(async res => {
        if (res.status === 404) return null;
        return res.json();
    })
    .then(res => callback(res))
    .catch(() => NotifyError("Kunde inte hämta Tork-inställningar."));
}

export const UpsertTorkSettings = (settings, jwtToken, callback) => {
    fetch(process.env.REACT_APP_API_BASE_URL + '/torksettings', {
        method: "PUT",
        body: JSON.stringify(settings),
        headers: {
            "Content-Type": "Application/json",
            Authorization: `Bearer ${jwtToken}`
        }
    })
    .then(res => res.json())
    .then(res => {
        NotifySuccess("Inställningar sparade!");
        callback(res);
    })
    .catch(() => NotifyError("Kunde inte spara inställningar."));
}
